import { AcAltGetStartedPageTreatments } from '../../../../utils/features';

export interface GetStartedCopy {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  info: React.ReactNode;
  cta: React.ReactNode;
}

interface GetStartedCopyProps {
  treatment: keyof typeof AcAltGetStartedPageTreatments;
  discountAmount: number;
}

const GET_STARTED_PAGE_COPY = {
  [AcAltGetStartedPageTreatments.off]: {
    title: <>Better food starts here.</>,
    subtitle: (
      <>Let’s determine your meal plan, recommended recipes, and daily price!</>
    ),
    info: <>This will only take ~3 minutes per dog.</>,
    cta: <>Continue</>,
  },
  [AcAltGetStartedPageTreatments.portions_and_price]: {
    title: <>Let’s determine your dog’s portions and price!</>,
    subtitle: (
      <>
        We use information like age, breed, and weight to calculate exactly how
        much they should eat per day.
      </>
    ),
    info: <>Personalized nutrition in ~3 minutes per dog.</>,
    cta: (discount: number) => (
      <>Continue Today with {discount.toString()}% Off</>
    ),
  },
  [AcAltGetStartedPageTreatments.personalized_nutrition]: {
    title: (
      <>
        Personalized nutrition <br />
        in ~3 minutes per dog.
      </>
    ),
    subtitle: (
      <>
        Based on your dog’s age, breed, and weight, we’ll create a plan with the
        right recipes, portions, and pricing.
      </>
    ),
    info: (discount: number) => (
      <>
        Continue to <b>get {discount.toString()}% off</b> your first box!
      </>
    ),
    cta: <>Let’s Go!</>,
  },
};

export const getGetStartedCopy = ({
  treatment,
  discountAmount,
}: GetStartedCopyProps): GetStartedCopy => {
  if (treatment === AcAltGetStartedPageTreatments.portions_and_price) {
    return {
      ...GET_STARTED_PAGE_COPY[treatment],
      cta: GET_STARTED_PAGE_COPY[treatment].cta(discountAmount),
    };
  }

  if (treatment === AcAltGetStartedPageTreatments.personalized_nutrition) {
    return {
      ...GET_STARTED_PAGE_COPY[treatment],
      info: GET_STARTED_PAGE_COPY[treatment].info(discountAmount),
    };
  }

  return GET_STARTED_PAGE_COPY[AcAltGetStartedPageTreatments.off];
};
